module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAD8SURBVFiF7ZS9DcIwEIV9lulDD9FJJANkA9iADVgBJgmbIOYIkulpTixAegymSUESGcnhcCTkV53Plt8n/zwhojykEZPTYr7m3FN6rZ48SynlQSPiKADWApvxIIBfKAKwAmjEZDQAjYh2Ym86T8tRAIwy2JRep9AD0HlaVhkuGZj8AapstrQCtgqeG24jV4qG+wWOFA0G4ErR/8qBCPBJIETdlPV7vwWgQLUmWWVg97CwKohaHup9UFzorPN0b6w8cvsXRCSEoG5f9RZerjtu809iewPKqHNTel0jG0BBVMMdpr4nyPoLug8sOMAQRQAvAFeaBQNwpVnUN3oBLVpLWeGahVAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/xuanzhong.png
// module id = Sc3B
// module chunks = 14